import script from "./confirmation-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmation-modal.vue?vue&type=script&setup=true&lang=js"

import "./confirmation-modal.vue?vue&type=style&index=0&id=842a64e2&lang=css"

const __exports__ = script;

export default __exports__